<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" >
            <div class="modal-container" style="max-height:100vh;overflow-y:scroll;">

              <div class="modal-header">
                <slot name="header">
                  Tick the permissions required
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  <div class="input-box">
                    <input type="checkbox" id="admin" value="admin" v-model="passedObject.permission">
                    <label for="admin">admin</label>
                  </div>
                  <div class="input-box">
                    <input type="checkbox" id="role-editor" value="editor" v-model="passedObject.permission">
                    <label for="role-editor">editor</label>
                  </div>
                  <div class="input-box">
                    <input type="checkbox" id="podcast" value="podcast" v-model="passedObject.permission">
                    <label for="podcast">podcast</label>
                  </div>
                  <div class="input-box">
                    <input type="checkbox" id="video" value="video" v-model="passedObject.permission">
                    <label for="video">video</label>
                  </div>
                  <div class="user-edit-screen">
                     <md-autocomplete v-model="passedObject.defaultAuthor" :md-options="authors || []" @md-changed="getAuthors" @md-opened="getAuthors">
                      <label>Author</label>

                      <template slot="md-autocomplete-empty" slot-scope="{ term }">
                        No Authors matching "{{ term }}" were found.
                      </template>

                      <template slot="md-autocomplete-item" slot-scope="{ item }"><span style="font-size:initial;">{{ item }}</span></template>
                    </md-autocomplete>
                  </div>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button" @click="editUser">
                    UPDATE USER
                  </button>
                  <button class="modal-default-button cancel-delete-button" @click="closeTheModal">
                    CANCEL
                  </button>
                </slot>
              </div>
            </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from "vue";
import firebase from 'firebase';
import VueFirestore from "vue-firestore";
require("firebase/firestore");
import Multiselect from "vue-multiselect";
Vue.use(VueFirestore);
var firestore;
  export default {
    name: 'modal',
    components: {
      Multiselect
    },
    props: {
      passedObject: {
          type: Object
      }
    },
    firestore() {
      return {

      };
    },
    data: function() {
      firestore = firebase.firestore();
      return {
        authors: []
      }
    },
    mounted: function() {
      if(this.passedObject.defaultAuthor) {
        firestore
          .collection("authors")
          .doc(this.passedObject.defaultAuthor)
          .get()
          .then((snap) => {
            var data = snap.data();
            if(data) this.authors = [data];
          });
      }
      if(!this.passedObject.permission) {
        this.passedObject.permission = [];
      }

    },
    methods: {
      getAuthors: function(searchTerm) {
        this.authors = new Promise(resolve => {
          if (!searchTerm) {
            resolve([])
          } else {
            searchTerm = searchTerm.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
            var strlength = searchTerm.length;
            var strFrontCode = searchTerm.slice(0, strlength-1);
            var strEndCode = searchTerm.slice(strlength-1, searchTerm.length);

            var startcode = searchTerm;
            var endcode= strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
            console.log(searchTerm);
            firestore
              .collection("authors")
              .where('slug', '>=', startcode)
              .where('slug', '<', endcode)
              .limit(20)
              .get()
              .then((snap) => {
                var data = snap.docs.map((documentSnapshot) => {
                  return documentSnapshot.data().slug;
                });
                console.log(data);
                resolve(data);
              });
          }
        })
      },
      editUser() {
        firestore
          .collection("users")
          .doc(this.$props.passedObject['.key'])
          .update({
            permission: this.passedObject.permission,
            defaultAuthor: this.passedObject.defaultAuthor
          });
        alert("User updated");
        this.$emit('update:modal');
    },
      closeTheModal() {
        this.$emit('update:modal');
     }
   }
  }
</script>

<style>
.result em {
  background-color: #ccc;
  color:black;
}
.user-edit-screen .md-autocomplete .md-menu input {
  color: black !important;
  -webkit-text-fill-color: black !important;
}
.md-field.md-theme-default:after {
    background-color: rgba(140, 139, 139, 0.7) !important;
}
.md-field.md-theme-default .md-helper-text, .md-field.md-theme-default .md-count, .md-field.md-theme-default label {
    color: rgba(140, 139, 139, 0.7) !important;
}
</style>

<style scoped>

.flex-row {
  display:flex;
}
input {
  display:block;
}
.cancel-delete-button {
  background-color: #ff5252;
}
.modal-mask {
  overflow-y:scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 550px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  color:#000000;
  text-align:center;
}

.modal-body {
  margin: 20px 0;
  color:#000000;
}

.modal-default-button {
  float: right;
}
.modal-footer {
  padding:10px;
}
.modal-footer button {
  margin-right:10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
}
.scrolling-wrapper-flexbox {
    display: flex;
    flex-wrap: nowrap;

    overflow-x:scroll;
    -webkit-overflow-scrolling: touch;
}
input {
      width: 500px;
}
</style>



// WEBPACK FOOTER //
// ModalUseredit.vue?12df282f